import React from 'react'

import { Text, TextName } from 'sdk/text/Text'
import { Button } from 'sdk/button/Button'
import BlueGridContainer from 'components/blue-grid-container/BlueGridContainer'

import styles from './BookDemoCTA.module.scss'

interface BookDemoCTAProps {
  title: string
  buttonText: string
  buttonUrl: string
}

const BookDemoCTA: React.FC<BookDemoCTAProps> = ({ title, buttonText, buttonUrl }) => {
  const isInternalUrl = buttonUrl.startsWith('/')

  return (
    <BlueGridContainer className={styles.container}>
      <Text type={TextName.H3} className={styles.title}>
        {title}
      </Text>
      <Button
        variant="blurred"
        as={isInternalUrl ? 'router-link' : 'link'}
        to={isInternalUrl ? buttonUrl : undefined}
        href={isInternalUrl ? undefined : buttonUrl}
      >
        {buttonText}
      </Button>
    </BlueGridContainer>
  )
}

export default BookDemoCTA
